import { track } from './shared/utils/mixpanel';
var rotomURL = process.env.BASE_URL;
if (typeof window !== 'undefined') {
    if (localStorage.getItem('rotom')) {
        // the rotom URL is expected to contain the root path
        rotomURL = "".concat(localStorage.getItem('rotom'), "/api/graphql");
    }
}
var digletURL = process.env.DIGLET_URL;
if (typeof window !== 'undefined') {
    digletURL = localStorage.getItem('pikachu') || digletURL;
}
var ehrURL = process.env.EHR_URL;
if (typeof window !== 'undefined') {
    ehrURL = localStorage.getItem('ehr') || ehrURL;
}
var consoleAuditLog = process.env.CONSOLE_AUDIT_LOGS;
export var ENABLE_WELCOME_MODAL = process.env.ENABLE_WELCOME_MODAL
    ? JSON.parse(process.env.ENABLE_WELCOME_MODAL)
    : true;
export var CONSOLE_AUDIT_LOGS = consoleAuditLog;
export var BASE_URL = rotomURL;
export var DIGLET_URL = digletURL;
export var EHR_URL = ehrURL;
export var EHR_LAUNCH_APPOINTMENT_DATE = '06/23/2022';
export var SCHEDULING_CONFIGS = {
    nodeEnv: process.env.NODE_ENV,
    baseUrl: BASE_URL,
    digletUrl: DIGLET_URL,
    ehrUrl: EHR_URL,
    mixpanelTrack: track,
};
export var S3CONFIG_BY_HOST_URL = process.env.S3CONFIG_BY_HOST_URL ||
    'https://scheduler-633306359953.s3.amazonaws.com/configByHost/';
/**
 * Gets the s3 url for the scheduling config file based on the current hostname
 *
 * If the hostname is localhost, it will return the local config file in /public
 *
 * @returns The s3 url for this config file based on the current hostname
 */
export var getSchedulingS3ConfigUrlFromHost = function () {
    var commonLocalHostnames = ['localhost', '127.0.0.1', '0.0.0.0'];
    return commonLocalHostnames.includes(window.location.hostname)
        ? "http://".concat(window.location.host, "/localSchedulerConfig.json")
        : "".concat(S3CONFIG_BY_HOST_URL).concat(window.location.host, ".json");
};
